import React from "react";
import UnauthorizedIcon from "../images/UnauthorizedIcon.svg";
import "./PaymentMode.scss";
import { ButtonCustom } from "../UI/ButtonCustom/ButtonCustom";

function UnderMaintenance() {
    const handleDoneClick = () => {
        const redirectUrl = localStorage.getItem('redirectUrl');
        if (redirectUrl) {
            localStorage.clear();
            window.location.replace(redirectUrl); // This will navigate to the new domain
        }
    };
    return (
        <div className="container">
            <div className="details commonBG">
                <img src={UnauthorizedIcon} alt="UnauthorizedIcon" />
                <h3>{localStorage.getItem('errorMessage')}</h3>

                <ButtonCustom basicBtn label="Done" onClick={handleDoneClick} />
            </div>
        </div>
    );
}

export default UnderMaintenance;
